export enum DELETING_OBJECT {
  pad = 'pad',
  rigOperation = 'rigOperation',
  rigOperationsList = 'rigOperationsList',
}
